import { Module } from "types/generated";
import { AccountViewer } from "components/form/graphql/types";

import { canManageModules } from "../utils";

export const canEnableModule = (module: Module, viewer: AccountViewer | undefined): boolean =>
  module.isDisabled && canManageModules(module, viewer);
